export const isInIframe = (): boolean => {
	try {
		return window.self !== window.top;
	} catch {
		return true;
	}
};
